module.exports = __webpack_public_path__ + "img/product-1-min.a31de5a2.jpeg";